export interface MarketingData {
  accepted: boolean;
  time: Date;
}
